import React, { useEffect, useState } from 'react';

// Вставить в глобальный CSS или index.css проекта:
// (стили тут inline через <style> тег для удобства — в проекте вынести в .css файл)

const styles = `
  @keyframes shieldFill {
    0%   { stroke-dashoffset: 120; }
    100% { stroke-dashoffset: 0; }
  }

  @keyframes shieldPulse {
    0%, 100% { filter: drop-shadow(0 0 0px #1a6cff44); }
    50%       { filter: drop-shadow(0 0 12px #1a6cff88); }
  }

  @keyframes dotBounce {
    0%, 80%, 100% { transform: translateY(0);   opacity: 0.4; }
    40%           { transform: translateY(-6px); opacity: 1;   }
  }

  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @keyframes progressBar {
    0%   { width: 15%; }
    30%  { width: 45%; }
    65%  { width: 72%; }
    90%  { width: 88%; }
    100% { width: 88%; }
  }

  .oauth-page {
    min-height: 100vh;
    background: #f0f2f5;
    display: flex;
    flex-direction: column;
  }

  .oauth-logo-shield {
    animation: shieldPulse 2.4s ease-in-out infinite;
  }

  .oauth-shield-arc {
    stroke-dasharray: 120;
    stroke-dashoffset: 120;
    animation: shieldFill 1.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s forwards;
  }

  .oauth-card {
    animation: fadeInUp 0.5s ease 0.1s both;
    border: none;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(26, 108, 255, 0.08), 0 1px 4px rgba(0,0,0,0.06);
  }

  .oauth-title {
    animation: fadeInUp 0.5s ease 0.25s both;
    font-size: 1.2rem;
    font-weight: 600;
    color: #1a1a2e;
    letter-spacing: -0.01em;
  }

  .oauth-subtitle {
    animation: fadeInUp 0.5s ease 0.35s both;
    font-size: 0.9rem;
    color: #6c757d;
  }

  .oauth-progress-wrap {
    animation: fadeInUp 0.5s ease 0.45s both;
    height: 4px;
    background: #e9ecef;
    border-radius: 99px;
    overflow: hidden;
  }

  .oauth-progress-bar {
    height: 100%;
    border-radius: 99px;
    background: linear-gradient(90deg, #1a6cff, #4d8fff);
    animation: progressBar 4s cubic-bezier(0.4, 0, 0.2, 1) 0.6s forwards;
  }

  .oauth-dots {
    animation: fadeInUp 0.5s ease 0.55s both;
  }

  .oauth-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #1a6cff;
    animation: dotBounce 1.4s ease-in-out infinite;
  }

  .oauth-dot:nth-child(1) { animation-delay: 0s;    }
  .oauth-dot:nth-child(2) { animation-delay: 0.18s; }
  .oauth-dot:nth-child(3) { animation-delay: 0.36s; }

  .oauth-step {
    animation: fadeInUp 0.5s ease 0.6s both;
    font-size: 0.8rem;
  }

  .oauth-step-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.65rem;
    font-weight: 700;
    flex-shrink: 0;
  }

  .step-done {
    background: #d1fae5;
    color: #065f46;
  }

  .step-active {
    background: #dbeafe;
    color: #1e40af;
  }

  .step-pending {
    background: #f3f4f6;
    color: #9ca3af;
  }
`;

// Статичний компонент логотипу-щита у брендовому стилі
function KyivShieldLogo({ size = 64 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="oauth-logo-shield"
    >
      {/* Фон щита */}
      <path
        d="M32 4 L56 14 L56 34 C56 47 44 57 32 60 C20 57 8 47 8 34 L8 14 Z"
        fill="#1a6cff"
      />
      {/* Буква К */}
      <path
        d="M22 20 L22 44 M22 32 L38 20 M22 32 L38 44"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Анімований обідок щита */}
      <path
        d="M32 4 L56 14 L56 34 C56 47 44 57 32 60 C20 57 8 47 8 34 L8 14 Z"
        fill="none"
        stroke="white"
        strokeWidth="2.5"
        strokeOpacity="0.6"
        className="oauth-shield-arc"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Іконка-чекмарк
function CheckIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M2 5 L4 7 L8 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

// Іконка спінера (маленький)
function SpinIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" style={{ animation: 'spin 0.9s linear infinite' }}>
      <circle cx="5" cy="5" r="3.5" stroke="currentColor" strokeWidth="1.8" strokeDasharray="8 4" strokeLinecap="round"/>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </svg>
  );
}

const STEPS = [
  { id: 'code',  label: 'Отримання коду авторизації', status: 'done'    },
  { id: 'token', label: 'Перевірка даних користувача', status: 'active'  },
  { id: 'session', label: 'Відкриття особистого кабінету', status: 'pending' },
];

export default function OAuthCallbackPage() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    // Тут буде ваша логіка: dispatch(handleOAuthCallback(code)) і т.д.
  }, []);

  if (!mounted) return null;

  return (
    <>
      <style>{styles}</style>

      <div className="oauth-page">
        {/* Мінімальний хедер у стилі порталу */}
        {false && <nav className="navbar" style={{ background: '#1a6cff', padding: '0 24px', height: 60, flexShrink: 0 }}>
          <div className="d-flex align-items-center gap-2">
            <KyivShieldLogo size={32} />
            <div style={{ lineHeight: 1.1 }}>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: '0.8rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                Дитячі садочки
              </div>
              <div style={{ color: '#ffffffaa', fontWeight: 600, fontSize: '0.72rem', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                Києва
              </div>
            </div>
          </div>
        </nav>}

        {/* Центральний блок */}
        <div className="flex-grow-1 d-flex align-items-center justify-content-center px-3">
          <div style={{ width: '100%', maxWidth: 400 }}>

            <div className="card oauth-card p-4">
              {/* Логотип і заголовок */}
              <div className="text-center mb-4">
                <KyivShieldLogo size={64} />
                <div className="oauth-title mt-3">Вхід до кабінету</div>
                <div className="oauth-subtitle mt-1">
                  Будь ласка, зачекайте — ідентифікуємо вас&nbsp;через Київ&nbsp;Цифровий
                </div>
              </div>

              {/* Прогрес-бар */}
              <div className="oauth-progress-wrap mb-3">
                <div className="oauth-progress-bar" />
              </div>

              {/* Кроки */}
              <div className="oauth-step mb-3">
                {STEPS.map((step) => (
                  <div key={step.id} className="d-flex align-items-center gap-2 py-2"
                    style={{ borderBottom: step.id !== 'session' ? '1px solid #f3f4f6' : 'none' }}
                  >
                    <span className={`oauth-step-icon ${
                      step.status === 'done'    ? 'step-done'    :
                      step.status === 'active'  ? 'step-active'  : 'step-pending'
                    }`}>
                      {step.status === 'done'   ? <CheckIcon />  :
                       step.status === 'active' ? <SpinIcon />   : '·'}
                    </span>
                    <span style={{
                      color: step.status === 'pending' ? '#9ca3af' :
                             step.status === 'active'  ? '#1e40af' : '#374151',
                      fontWeight: step.status === 'active' ? 600 : 400,
                    }}>
                      {step.label}
                    </span>
                  </div>
                ))}
              </div>

              {/* Точки-аніматор */}
              <div className="oauth-dots text-center">
                <span className="oauth-dot mx-1" />
                <span className="oauth-dot mx-1" />
                <span className="oauth-dot mx-1" />
              </div>
            </div>

            {/* Підказка знизу */}
            <p className="text-center mt-3" style={{ fontSize: '0.78rem', color: '#9ca3af' }}>
              Не закривайте вкладку — це займе кілька секунд
            </p>
          </div>
        </div>
      </div>
    </>
  );
}